import { z } from "zod";
import { logger } from "@/logger";
import { jsonAutocomplete } from "@/utils/json/autocomplete";
import { jsonClean } from "@/utils/json/clean";

export function jsonParse<T extends z.ZodTypeAny>({
	input,
	schema,
}: {
	input: string;
	schema: T;
}): z.infer<T> | undefined {
	const cleaned = jsonClean(input);
	const completed = jsonAutocomplete(cleaned);
	const wrapperSchema = z.object({ data: schema });

	if (!completed) {
		return;
	}

	if (input === "[]") {
		return [];
	}

	try {
		return wrapperSchema.parse(JSON.parse(completed)).data;
	} catch (error) {
		logger.getLogger("jsonParse").error({ error, input, cleaned, completed });
	}
}
